import React from 'react';
import cn from 'classnames';
import classes from './Toolbar.module.scss';

export const Toolbar = ({ start, center, end, elevation = 2 }) => {
  return (
    <div className={classes.toolbar}>
      <div
        className={cn(classes.container, {
          [classes[`elevation-${elevation}`]]: elevation > 0,
        })}>
        {start && <div className={cn(classes.start, 'toolbar-start')}>{start}</div>}
        {center && <div className={cn(classes.center, 'toolbar-center')}>{center}</div>}
        {end && <div className={cn(classes.center, 'toolbar-end')}>{end}</div>}
      </div>
    </div>
  );
};
